import DOMPurify from 'dompurify'
import MarkdownIt from 'markdown-it'

const markdown = new MarkdownIt({
  breaks: true,
  html: false,
  linkify: true,
  typographer: true,
})

export const renderCustomerServiceMarkdown = (content: string, showStreamingTail = false) => {
  const html = DOMPurify.sanitize(markdown.render(content), {
    ALLOWED_TAGS: ['a', 'blockquote', 'br', 'code', 'del', 'em', 'h1', 'h2', 'h3', 'h4', 'hr', 'li', 'ol', 'p', 'pre', 'strong', 'ul'],
    ALLOWED_ATTR: ['href', 'title'],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|weixin):|[^a-z]|[a-z+.-]+(?:[^a-z+.-]|$))/i,
  })
  const document = new DOMParser().parseFromString(html, 'text/html')
  document.querySelectorAll('a[href="weixin://shopping/mall/index"]').forEach((link) => link.classList.add('mall-link'))
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
  const textNodes: Text[] = []
  let node: Node | null
  while ((node = walker.nextNode())) {
    if (node.textContent?.includes('www.njyjxr.com') && !node.parentElement?.closest('a, code, pre')) textNodes.push(node as Text)
  }
  textNodes.forEach((textNode) => {
    const fragment = document.createDocumentFragment()
    textNode.textContent?.split('www.njyjxr.com').forEach((part, index, parts) => {
      if (part) fragment.append(document.createTextNode(part))
      if (index < parts.length - 1) {
        const link = document.createElement('a')
        link.href = 'https://www.njyjxr.com/'
        link.textContent = 'www.njyjxr.com'
        fragment.append(link)
      }
    })
    textNode.replaceWith(fragment)
  })
  if (showStreamingTail) {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
    let lastTextNode: Text | undefined
    let node: Node | null
    while ((node = walker.nextNode())) {
      if (node.textContent?.trim()) lastTextNode = node as Text
    }
    if (lastTextNode?.parentNode) {
      const text = lastTextNode.textContent ?? ''
      const characters = Array.from(text)
      const tailLength = Math.min(4, characters.length)
      const tail = characters.splice(-tailLength).join('')
      const fragment = document.createDocumentFragment()
      if (characters.length) fragment.append(document.createTextNode(characters.join('')))
      const tailElement = document.createElement('span')
      tailElement.className = 'streaming-tail'
      tailElement.textContent = tail
      fragment.append(tailElement)
      lastTextNode.replaceWith(fragment)
    }
  }
  return document.body.innerHTML.trimEnd()
}
